export default function PDFVEditAIAccountDeletion() {
  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#A8720E]">
            Account Deletion – PDF Viewer &amp; Editor - AI
          </h1>
          <p className="mt-2 text-sm text-[#5B6B7C]">
            How to permanently delete your account and data.
          </p>
          <p className="mt-1 text-xs text-[#8A93A2]">
            Published by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="space-y-8 leading-relaxed text-[#3D4B59]">
          <p>
            At <strong>Cosmovex</strong>, we respect your privacy and believe
            you should have complete control over your data. You may request the
            permanent deletion of your account and all related data at any time.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            How to Request Deletion
          </h2>
          <p>
            To request deletion of your account and all associated data, please
            email us at:
          </p>
          <p className="text-lg font-semibold text-[#A8720E]">
            <a
              href="mailto:cosmovex.apps@gmail.com"
              className="underline text-[#0F6BBF] hover:text-[#0C5AA3]"
            >
              cosmovex.apps@gmail.com
            </a>
          </p>
          <p>
            Please use the <strong>same email address</strong> associated with
            your account to verify your identity. Once your request is verified,
            we will permanently delete your account and all related data within{" "}
            <strong>7 business days</strong>.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            What Data Will Be Deleted
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              Your user profile details (name, email, profile photo) stored in
              Firebase Authentication.
            </li>
            <li>
              Your AI chat history, document metadata, and credits balance
              stored in Firebase Firestore.
            </li>
            <li>
              Your purchase and subscription records linked to your account.
            </li>
            <li>Any usage or analytics data linked to your user account.</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            What Data Is Retained
          </h2>
          <p>
            Some aggregated or anonymized data may remain for performance
            analysis and legal compliance purposes, but it will never be
            personally identifiable.
          </p>
          <p>
            PDF files processed locally on your device are not stored on our
            servers and are not affected by account deletion.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Need Help?</h2>
          <p>
            If you have any questions regarding data deletion, account
            management, or privacy concerns, contact us at{" "}
            <a
              href="mailto:cosmovex.apps@gmail.com"
              className="text-[#0F6BBF] underline hover:text-[#0C5AA3]"
            >
              cosmovex.apps@gmail.com
            </a>
            .
          </p>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-center text-sm text-[#8A93A2]">
          © {new Date().getFullYear()} Cosmovex — All rights reserved.
        </footer>
      </section>
    </main>
  );
}
